import { OnboardingStatusEnum } from '../models/onboarding.model';

export const onboardingMock = {
  user: {
    id: 'u-123',
    studentId: 'QX-2026-8942',
    name: 'Ankit',
    email: 'ankit@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Ankit',
    workspaceStatus: 'Provisioning',
  },
  resume: {
    lastActive: 'Yesterday at 8:42 PM',
    currentStepName: 'Engineering Profile Completion',
    estimatedMinutes: 3,
    actionText: 'Resume Engineering Journey',
  },
  progress: {
    currentStepIndex: 1,
    totalSteps: 5,
    percentage: 20,
    estimatedMinutesLeft: 12,
  },
  todayGoal: {
    title: 'Complete Engineering Profile',
    why: 'It helps us personalize your engineering environment and tools.',
    reward: 'Unlock Experience Selection',
    estimatedMinutes: 3,
  },
  checklist: [
    {
      id: 'step-1',
      title: 'Complete Engineering Profile',
      why: 'It helps us personalize your engineering environment and tools.',
      reward: 'Unlock Experience Selection',
      status: OnboardingStatusEnum.IN_PROGRESS,
      actionText: 'Resume Engineering Journey',
      estimatedMinutes: 3,
    },
    {
      id: 'step-2',
      title: 'Select Experience',
      why: 'To ensure we assign you to the correct engineering track and dashboard tier.',
      reward: 'Dashboard Assigned',
      status: OnboardingStatusEnum.LOCKED,
      actionText: 'Select Experience',
      estimatedMinutes: 2,
    },
    {
      id: 'step-3',
      title: 'Choose Program',
      why: 'To officially join a specialized virtual engineering team (e.g., Frontend, Backend).',
      reward: 'Program Enrolled',
      status: OnboardingStatusEnum.LOCKED,
      actionText: 'Choose Program',
      estimatedMinutes: 5,
    },
    {
      id: 'step-4',
      title: 'Payment',
      why: 'To secure your seat and finalize your enrollment in the engineering program.',
      reward: 'Seat Confirmed',
      status: OnboardingStatusEnum.LOCKED,
      actionText: 'Proceed to Payment',
      estimatedMinutes: 2,
    },
    {
      id: 'step-5',
      title: 'Unlock Workspace',
      why: 'Final celebratory step to launch your workspace.',
      reward: 'Engineering Access',
      status: OnboardingStatusEnum.LOCKED,
      actionText: 'Launch Engineering Workspace',
      estimatedMinutes: 0,
    },
  ],
  timeline: [
    { title: 'Join QEVRIX', status: 'COMPLETED' },
    { title: 'Engineering Profile', status: 'ACTIVE' },
    { title: 'Choose Program', status: 'UPCOMING' },
    { title: 'Engineering Workspace', status: 'UPCOMING' },
    { title: 'Sprint', status: 'UPCOMING' },
    { title: 'Projects', status: 'UPCOMING' },
    { title: 'Production Deployment', status: 'UPCOMING' },
    { title: 'Internship', status: 'UPCOMING' },
    { title: 'Career Support', status: 'UPCOMING' },
  ],
  quickActions: [
    { title: 'Engineering Profile', description: 'Finish your basic setup.', iconName: 'User', comingSoon: false },
    { title: 'Engineering Program', description: 'View track details.', iconName: 'Code', comingSoon: false },
    { title: 'Engineering Support', description: 'Get help from our team.', iconName: 'LifeBuoy', comingSoon: false },
    { title: 'Engineering FAQs', description: 'Browse common questions.', iconName: 'HelpCircle', comingSoon: false },
    { title: 'Engineering Community', description: 'Join fellow engineers.', iconName: 'Users', comingSoon: true },
  ],
};
